import React from 'react';
import { TableCell, IconButton } from '@material-ui/core';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Delete as DeleteIcon, Edit as EditIcon } from '@material-ui/icons';

import getPersonnelNameById from '../../../mappers/getPersonnelNameById';

const useStyles = makeStyles((theme) => ({
  deleteIcon: {
    color: theme.palette.danger.minor
  },
  cancelButton: {
    marginLeft: 10,
    color: theme.palette.subTitle.main
  }
}));

const SingleCourseRecord = (props) => {
  const classes = useStyles();
  const {
    record,
    userId,
    personnels,
    handleDeleteCourseRecordClick,
    enableEditCourseRecord
  } = props;
  const personnelName = getPersonnelNameById(personnels, record.personnelId);
  const isValidExpiry =
    record.nextCourseDate != record.recordDate &&
    moment(record.nextCourseDate).isAfter(moment.utc('0001-01-01'));

  return (
    <React.Fragment>
      <TableCell component="th" scope="row">
        {personnelName}
      </TableCell>
      <TableCell component="th" scope="row">
        {moment(record.recordDate).format('DD MMM YYYY')}
      </TableCell>
      <TableCell component="th" scope="row">
        {isValidExpiry
          ? moment(record.nextCourseDate).format('DD MMM YYYY')
          : 'none'}
      </TableCell>
      <TableCell component="th" scope="row">
        {record.notes}
      </TableCell>
      <TableCell component="th" scope="row" align="center">
        <IconButton
          aria-label="edit"
          className={classes.editIcon}
          size="small"
          onClick={() => enableEditCourseRecord(true, record.id, userId)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="delete"
          className={classes.deleteIcon}
          size="small"
          onClick={() => handleDeleteCourseRecordClick(record.id)}
        >
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </React.Fragment>
  );
};

export default SingleCourseRecord;
